import ControlFactory from '@/Factories/ControlFactory';
import Factory from '@/Factories/Factory';
import ComponentManager from '@/Management/ComponentManager';
import RADEnvironmentProxy from '@/Communication/RADEnvironmentProxy';
import { IListViewDTO } from "coreframetypings/dto";

export default class PrincipalHistorizationGroupFactory extends ControlFactory {

    private jQueryControl: JQuery;
    public associationGridFactory: any;

    public constructor(private params: any) {
        super(params);
    }

    /**
     * @override
     */
    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = $('<div>');

        this.labelPosition = this.paramOrDefault('Top');

        $.when(this.params.context.removeDefaultIterator(this.params.detailViewItem.name)).then((result: any) => {
            this.getConvertedListView(this.params.detailViewItem.listView, this.params.context.genericObject).then((listViewDTO: IListViewDTO) => {
                if (listViewDTO != null) {
                    this.params.detailViewItem.listView = listViewDTO;

                    this.associationGridFactory = Factory.createInstance('AssociationGridFactory', this.params);
                    let tuple = this.associationGridFactory.getTuple();

                    tuple.control.appendTo(this.jQueryControl);
                }
            })
        });

        return this.jQueryControl;
    }

    private getConvertedListView(source: IListViewDTO, genericObject: any): any {
        return RADEnvironmentProxy.getInstance().getListViewByName({
            listViewName: this.context.genericObject.getValue('Name') + '_LV'
        }).then((listViewDTO: IListViewDTO) => {
            if (!this.validateStatus(listViewDTO))
                return undefined;

            listViewDTO.showButtonCreate = source.showButtonCreate;
            listViewDTO.showButtonCSVExport = source.showButtonCSVExport;
            listViewDTO.showButtonDelete = source.showButtonDelete;
            listViewDTO.showButtonDisconnect = source.showButtonDisconnect;
            listViewDTO.showButtonEdit = source.showButtonEdit;
            listViewDTO.showButtonFilter = source.showButtonFilter;
            listViewDTO.showButtonSelect = source.showButtonSelect;
            listViewDTO.showButtonXLSExport = source.showButtonXLSExport;
            listViewDTO.showButtonPDFExport = source.showButtonPDFExport;
            listViewDTO.showMoveButtons = source.showMoveButtons;
            listViewDTO.showButtonCustomColumns = false;
            listViewDTO.assoziationListView = true;
            listViewDTO.relationName = source.relationName;

            return listViewDTO;
        })
    }
}

ComponentManager.setFactory('RADPresentation.DefaultViewExtensions.UIComponents.PrincipalHistorizationGroup', PrincipalHistorizationGroupFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');